export default __webpack_public_path__ + "static/media/savedjobIcon.8452eb58.svg";